import gql from "graphql-tag";

export const BROKER_TRANSACTION_FIELDS = gql`
    fragment BrokerTransactionFields on BrokerTransaction {
        _id
        brokerId
        broker {
            _id
            name
        }
        clientId
        client {
            _id
            name
        }
        type
        description
        isin
        instrument {
            _id
            name
        }
        price
        quantity
        commission
        stampDuty
        currency
        settlementAmount
        tradeDate
        valueDate
        reportId
        externalId
        correspondingTransactionId
        error
        status
        createTimestamp
        updateTimestamp
        updateUserInfo {
            name
        }
        versions @include(if: $includeVersions)
    }
`;

export const BROKER_TRANSACTIONS_QUERY = gql`
    ${BROKER_TRANSACTION_FIELDS}
    query brokerTransactions($filter: BrokerTransactionFilterInput, $includeVersions: Boolean = false) {
        brokerTransactions(filter: $filter) {
            ...BrokerTransactionFields
        }
    }
`;

export const BROKER_TRANSACTIONS_AND_CLIENTS_QUERY = gql`
    ${BROKER_TRANSACTION_FIELDS}
    query brokerTransactions($filter: BrokerTransactionFilterInput, $includeVersions: Boolean = false) {
        brokerTransactions(filter: $filter) {
            ...BrokerTransactionFields
        }
        clients: parties(filter: { typeIn: [Client], statusIn: [Confirmed] }) {
            _id
            name
        }
    }
`;

export const UPDATE_STATUS_BROKER_TRANSACTION = gql`
    mutation UpdateBrokerTransaction($input: UpdateBrokerTransactionInput!) {
        updateBrokerTransaction(input: $input) {
            _id
            status
        }
    }
`;

export const UPDATE_BROKER_TRANSACTION = gql`
    ${BROKER_TRANSACTION_FIELDS}
    mutation UpdateBrokerTransaction($input: UpdateBrokerTransactionInput!, $includeVersions: Boolean = false) {
        updateBrokerTransaction(input: $input) {
            ...BrokerTransactionFields
            updateUserId
        }
    }
`;

export const MATCH_TRANSACTIONS = gql`
    mutation MatchTransactions($input: [MatchTransactionsInput!]!) {
        matchTransactions(input: $input) {
            brokerTransaction {
                _id
                status
                error
                correspondingTransactionId
            }
            transaction {
                _id
                status
                error
                brokerTradeId
            }
        }
    }
`;
